var map = {
	"./arrow-down-blue.svg": 451,
	"./arrow-down-grey.svg": 452,
	"./arrow-down-up.svg": 453,
	"./arrow-right-white.png": 454,
	"./arrow-right.svg": 455,
	"./blue-loader.svg": 193,
	"./bnb-logo.png": 143,
	"./circle-grey.svg": 456,
	"./circle.svg": 457,
	"./coinbaseWalletIcon.svg": 144,
	"./dropdown-blue.svg": 458,
	"./dropdown.svg": 459,
	"./dropup-blue.svg": 460,
	"./ethereum-logo.png": 461,
	"./fortmaticIcon.png": 145,
	"./k-logo.png": 127,
	"./link.svg": 462,
	"./magnifying-glass.svg": 463,
	"./menu.svg": 464,
	"./metamask.png": 194,
	"./plus-blue.svg": 465,
	"./plus-grey.svg": 466,
	"./portisIcon.png": 146,
	"./question-mark.svg": 467,
	"./question.svg": 468,
	"./spinner.svg": 469,
	"./token-list/lists-dark.png": 195,
	"./token-list/lists-light.png": 196,
	"./trustWallet.png": 470,
	"./walletConnectIcon.svg": 147,
	"./x.svg": 471
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 180;